/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Modal } from 'react-bootstrap';
import Actions from '@redux/app';
import PaymentMethodForm from './PaymentMethodForm';

class AddPaymentMethodModal extends Component {
	onExit = () => {
		const { resetForm } = this.props;
		resetForm('addPayment');
	}

	render() {
		const {
			user,
			showModal,
			callback,
			achPrePayEnabled,
		} = this.props;

		return (
			<Modal
				show={showModal}
				onHide={this.onExit}
				id="add-payment-modal"
			>
				<Modal.Header closeButton>
					<Modal.Title>Add Payment Method</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<PaymentMethodForm
						user={user}
						successCallback={callback}
						onCancel={this.onExit}
						achPrePayEnabled={achPrePayEnabled}
					/>
				</Modal.Body>
			</Modal>
		);
	}
}

const mapStateToProps = ({
	app : {
		addPayment : { showAddPayment },
		loaders : {
			addPaymentMethod : loadingAddPaymentMethod,
		},
	},
}) => ({
	loadingAddPaymentMethod,
	showModal : showAddPayment,
});

const mapDispatchToProps = (dispatch) => ({
	resetForm : bindActionCreators(Actions, dispatch).resetForm,
});

AddPaymentMethodModal.propTypes = {
	showModal        : PropTypes.bool,
	resetForm        : PropTypes.func.isRequired,
	callback         : PropTypes.func,
	user             : PropTypes.object,
	achPrePayEnabled : PropTypes.bool,
};

AddPaymentMethodModal.defaultProps = {
	showModal        : false,
	callback         : undefined,
	user             : {},
	achPrePayEnabled : false,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddPaymentMethodModal);
